import React, { ReactNode } from 'react';
import { FormControl as BaseUIFormControl, FormControlProps } from 'baseui/form-control';

import { TechemTheme } from '@techem/techem-theme';

interface CustomFormControlProps extends FormControlProps {
  additionalTestId?: string;
  required?: boolean;
}

const FormControl = (props: CustomFormControlProps) => {
  const buildLabel = (
    label: string | ReactNode | ((props: {}) => ReactNode),
    required?: boolean
  ) => {
    const labelDescription = typeof label === 'function' ? label({}) : label;

    const labelDescriptionElement = (
      <span className="fw-bold fs-6 lh-base" style={{ color: TechemTheme.colors.mono900 }}>
        {labelDescription}
      </span>
    );
    const asteriskElement = <span style={{ color: TechemTheme.colors.mono600 }}>&nbsp;*</span>;

    return required ? (
      <>
        {labelDescriptionElement} {asteriskElement}
      </>
    ) : (
      labelDescriptionElement
    );
  };

  return (
    <BaseUIFormControl
      {...props}
      overrides={{
        ControlContainer: {
          props: {
            'data-gi': `form-control-container${
              props.additionalTestId ? ' ' + props.additionalTestId : ''
            }`
          }
        },

        Label: {
          component: () => buildLabel(props.label, props.required),
          props: {
            'data-gi': `label${props.additionalTestId ? ' ' + props.additionalTestId : ''}`
          },
          style: {
            fontSize: '0.875rem',
            color: TechemTheme.colors.contentSecondary
          }
        },
        Caption: {
          props: {
            'data-gi': `caption${props.additionalTestId ? ' ' + props.additionalTestId : ''}`
          },
          style: {
            color: props.error ? TechemTheme.colors.negative : TechemTheme.colors.contentSecondary
          }
        }
      }}
    >
      {props.children}
    </BaseUIFormControl>
  );
};
export default FormControl;
